<template>
  <div class="wrap">
    <div class="query-banner">
      <p>证书验真</p>
    </div>
    <reason v-if="!hasResult" />
    <result v-else />
  </div>
</template>
<script>
import reason from "./reason.vue"
import result from "./result.vue"
import { mapActions, mapGetters,mapMutations } from "vuex"

export default {
  name: '',
  props: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      hasResult:"certificate/hasResult",
    })
  },
  created(){
  },
  watch: {
  },
  beforeUnmount(){
      this.SET_HASRESULT(false)
  },
  methods: {
    ...mapMutations({
      SET_HASRESULT:"certificate/SET_HASRESULT"
    }),
    ...mapActions({
      get_check_result:"certificate/get_check_result"
    })
  },
  components: {
    reason,
    result
  },
  filters: {}
};
</script>
<style lang='scss'>
.query-banner{
  position: relative;
}


</style>